<template>
    <div class="box-offset">
        <div class="center-separated-block center-separated-block-half">

            <div class="half-block">
                <div id="accordion" class="accordion">

                    <ApplicantStageSelector
                        :type="`pending`"
                        :accordion-card-id="'collapseOne'"
                        :accordion-style="`accordion--btn accordion--btn-secondary-bg`"
                        :accordion-card-title="`In Process`"
                        :active-status-tab="activeStatusTab"
                        :list-of-items="pendingStatuses"
                        :pending-length="pendingStatuses.length"
                        :active-length="activeStatuses.length"
                        @change-tab="setStageInfo"
                    />

                    <ApplicantStageSelector
                        :type="`active`"
                        :accordion-card-id="'collapseTwo'"
                        :active-status-tab="activeStatusTab"
                        :accordion-style="`accordion--btn accordion--btn-green-bg`"
                        :accordion-card-title="`Active`"
                        :list-of-items="activeStatuses"
                        :pending-length="pendingStatuses.length"
                        :active-length="activeStatuses.length"
                        @change-tab="setStageInfo"
                    />

                    <ApplicantStageSelector
                        v-if="showTerminationTab"
                        :type="`terminate`"
                        :accordion-card-id="'collapseThree'"
                        :active-status-tab="activeStatusTab"
                        :accordion-style="`accordion--btn accordion--btn-red-bg`"
                        :accordion-card-title="`Termination Information`"
                        :list-of-items="terminationStatuses"
                        :pending-length="pendingStatuses.length"
                        :active-length="activeStatuses.length"
                        @change-tab="setStageInfo"
                    />
                </div>
            </div>

            <div class="sep-line"></div>
            <div class="half-block">
                <StatusItemInfo
                    v-if="activeStatusTab && showRegularStatuses"
                    v-show="showRegularStatuses"
                    :user-status-info="activeStatusTab"
                    :user-id="userInfo.id"
                    :is-toggleable="userInfo.status !== 'inactive'"
                ></StatusItemInfo>

                <DeactivationStatus
                    v-if="showDeactivation"
                    :status-info="activeStatusTab"
                ></DeactivationStatus>

                <ReactivationStatus
                    v-if="showReactivation"
                    :status-info="activeStatusTab"
                ></ReactivationStatus>

            </div>
        </div>
    </div>
</template>

<script>
import StatusItemInfo from "../related/StatusItemInfo.vue";
import DeactivationStatus from "../related/DeactivationStatus.vue";
import ReactivationStatus from "../related/ReactivationStatus.vue";
import DateConverter from "../../../../../../resources/js/mixins/DateConverter";
import index from "vuex";
import ApplicantStageSelector from "../related/ApplicantStageSelector.vue";

export default {
    name: 'Status',
    components: {ApplicantStageSelector, ReactivationStatus, DeactivationStatus, StatusItemInfo},
    props: {
        userInfo: {
            type: Object
        }
    },
    mixins: [DateConverter],
    data() {
        return {
            activeStatuses:[],
            pendingStatuses: [],
            terminationStatuses: this.userInfo.applicant_status_histories ?? [],

            showRegularStatuses: true,
            showReactivation: false,
            showDeactivation: false,

            emptyTemplate: true,

            listOfStatuses: this.userInfo.status_items,

            activeStatusTab: null,
        }
    },
    computed: {
        showTerminationTab() {
            if (this.userInfo.applicant_status_histories && this.userInfo.applicant_status_histories.length > 0) {
                return true
            }
        }
    },
    methods: {
        sortByStatus() {
            this.activeStatuses = this.listOfStatuses.filter((item) => item.template.status === 'active')
            this.pendingStatuses = this.listOfStatuses.filter((item) => item.template.status === 'in_process')
            this.setStageInfo(this.pendingStatuses[0])
        },
        setStageInfo(status) {
            this.activeStatusTab = status

            if (status.action && status.action === 'deactivate') {
                this.showDeactivation = true
                this.showReactivation = false
                this.showRegularStatuses = false
            } else if (status.action && status.action === 'reactivate') {
                this.showReactivation = true
                this.showDeactivation = false
                this.showRegularStatuses = false
            } else {
                this.showRegularStatuses = true
                this.showDeactivation = false
                this.showReactivation = false
            }
        }
    },
    mounted() {
        this.sortByStatus()
    }
}

</script>

<style scoped>

</style>
